import { PhotoUpload } from '@otw/models/photos'
import { addDoc, collection } from 'firebase/firestore'
import { db } from '../../config/firebase'

export interface CreatePhotoUploadProps {
  userId: string
  vehicleIds: string[]
  accessCode?: string
  expiresAt?: Date
}

export const createPhotoUpload = async (props: CreatePhotoUploadProps): Promise<string> => {
  const { userId, vehicleIds, accessCode, expiresAt } = props
  
  const photoUploadData: Omit<PhotoUpload, 'id'> = {
    role: 'client',
    email: '',
    userId,
    vehicleIds,
    submittedVehiclesCount: 0,
    dateCreated: new Date().toISOString(),
    submissionCount: 0,
    vehicles: [],
    preDeliverySubmissions: 0,
    postDeliverySubmissions: 0,
    status: 'active',
    ...(accessCode && { accessCode }),
    ...(expiresAt && { expiresAt: expiresAt.toISOString() }),
  }

  const docRef = await addDoc(collection(db, 'photoUploads'), photoUploadData)
  return docRef.id
} 